module.exports = __webpack_public_path__ + "img/brandmark_gr-wht.d23850e.svg";